import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setExplainWithAIWidgetData,
  setExplainWithCurrentBillingData,
} from "@/store/explain-with-ai/explainWithAiSlice";
import { billingExplorerWidgetByIdSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/widget-view/billingExplorerWidgetByIdSelector";
import { RootState } from "@/store/store";
import { ExplainWithAiData } from "@/store/explain-with-ai/utils/types/common";

export const setExplainWithAiDataByWidgetIdFromDashboardThunk =
  createAsyncThunk(
    "dashboards/setExplainWithAiDataByWidgetIdFromDashboard",
    async (widgetId: string, { dispatch, getState }) => {
      const state = getState() as RootState;
      const widgetName = billingExplorerWidgetByIdSelector(
        state,
        widgetId,
      )?.name;
      const widget = billingExplorerWidgetByIdSelector(state, widgetId);

      if (widget?.grouping && widget?.trend_type && widget?.dates) {
        const currentData: ExplainWithAiData = {
          key: "currentBillingData",
          payload: {
            group_by: widget?.grouping,
            trend_type: widget?.trend_type,
            dates: widget?.dates,
            widgetName,
          },
        };

        dispatch(setExplainWithCurrentBillingData(currentData));

        dispatch(
          setExplainWithAIWidgetData({
            id: widgetId,
          }),
        );
      }
    },
  );
